module.exports = " <div class=towards-zero v-bind:class=\"{ '-menu-opened' : isNavMenuOpenedDelay }\"> <div class=project-title> <a v-link=\"{ name: 'home' }\" v-on:click=logoClicked tabindex=0 aria-label=\"Back to Project Graham Homepage\"> <div class=svg-container-logo> <img class=logo src=" + require("../assets/images/logo.png") + " alt=\"Project Graham Logo\"> </div> </a> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader?attrs=img:src img:data-fallback-src!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Towards.vue
// module id = 554
// module chunks = 10